import request from 'utils/request';
import { toastr } from 'react-redux-toastr';
import { dateTimeNow, convertEnglishDate } from 'utils/helpers';
import { QUOTE_ASSET_PRICE_URL, QUOTE_STUCTURE_PRICE_URL, QUOTE_SAVED_URL } from 'utils/api';

export const getSpot = async ({ beforeBack, callBack, asset }) => {
  beforeBack();
  return new Promise((resolve) => {
    request(`${QUOTE_ASSET_PRICE_URL}?ativo=${asset}`)
      .then(response => {
        const data = { spot: 0 };

        if (!response.error) {
          const responseJSON = JSON.parse(response);
          data.spot = responseJSON?.UltimoPreco || 0.1
        } else {
          toastr.error('Erro ao carregar o preço da ação', 'Tente novamente mais tarde');
        }

        callBack();
        resolve(data);
      })
  });
};

export const getPrice = async ({ beforeBack, legs, commission, callBack }) => {
  beforeBack();

  const payload = {
    pernas: [],
    comissao: commission
   };

  payload.pernas = legs
    .filter(leg => !leg.compraAtivo)
    .map(leg => ({
      spot: leg.spot,
      lado: leg.operacao,
      nomeAtivo: leg.asset,
      tipoPerna: leg?.opcao,
      tipoOpcao: leg.tipoOpcao,
      strike: leg.strike.value,
      estiloOpcao: leg.estiloOpcao,
      quantidade: leg.quantity.value,
      vencimento: convertEnglishDate(leg.maturityDate),
    }));

  return new Promise((resolve) => {
    request(QUOTE_STUCTURE_PRICE_URL, {
        data: payload,
        method: 'POST'
      })
      .then(response => {
        const data = { data: null };
        if (!response.error) {
          const { precoEstrutura } = response;

          data.data = {
            commissionMinimum: 0.01,
            commissionMaximum: 0.07,
            dateTimeQuote: dateTimeNow(),
            endPrice: 0.01 + precoEstrutura,
            indicativePrice: precoEstrutura,
          }
        } else {
          toastr.error('Erro ao carregar o preço', 'Tente novamente mais tarde');
        }

        callBack();
        resolve(data);
      })
  });
};

export const postQuote = async ({ beforeBack, callBack, data }) => {
  beforeBack();

  const { legs, quoteName, commission, endPrice, isQuoteUpdate, quoteEdit } = data;

  return new Promise((resolve) => {
    const payload = {
      nomeEstrutura: quoteName,
      valorEstrutura: endPrice || 0,
      valorComissao: commission,
      indRolagem: legs[0]?.reverse,
      idEstruturaNome: legs[0]?.idEstruturaNome,
      pernas: legs.map(leg => ({
        lado: leg.operacao,
        valorAtivo: leg.spot,
        tipoPerna: leg.opcao,
        nomeAtivo: leg.asset,
        valorStrike: leg?.strike?.value,
        quantidade: leg?.quantity?.value,
        datVencimento: convertEnglishDate(leg.maturityDate),
        idPernaEstruturaFavorita: leg?.idPernaEstruturaFavorita || 0,
      }))
    };

    if (isQuoteUpdate) {
      payload.idEstruturaFavorita = quoteEdit?.idEstruturaFavorita
    }

    request(QUOTE_SAVED_URL, {
      data: payload,
      method: isQuoteUpdate ? 'PUT' : 'POST'
    })
    .then(response => {
      const data = { data: null };

      if (!response.error) {
        data.data = true;
      } else {
        toastr.error('Erro ao salvar cotação', 'Tente novamente mais tarde');
      }

      callBack();
      resolve(data);
    })
  });
};

export const deleteQuote = async ({ quote, beforeBack, callBack }) => {
  beforeBack();
  return new Promise((resolve) => {
    const payload = quote;

    request(`${QUOTE_SAVED_URL}/${quote?.idEstruturaFavorita}`, {
      data: payload,
      method: 'DELETE'
    })
      .then(response => {
        const data = { data: null };

        if (!response.error) {
          data.data = true;
        } else {
          toastr.error('Erro ao salvar cotação', 'Tente novamente mais tarde');
        }

        callBack();
        resolve(data);
      })
  });
};
